import React from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import LoginHeader from "./LoginHeader";
import LoginForm from "./LoginForm";
import LoginFooter from "./LoginFooter";
import useLoginAuth from "./useLoginAuth";
import { getPageContainerProps, getCardContainerProps } from "./loginStyles";

/**
 * Main login page component. Composes header, form, and footer sub-components.
 * Uses the useLoginAuth hook for authentication state and logic.
 * @returns {React.ReactElement}
 */
function Login() {
    const isMobile = useBreakpointValue({ base: true, sm: false });
    const { email, setEmail, password, setPassword, showPassword, setShowPassword, loading, auth } = useLoginAuth();

    return (
        <Box {...getPageContainerProps()}>
            <Box {...getCardContainerProps()}>
                <LoginHeader isMobile={isMobile} />
                <LoginForm
                    email={email} setEmail={setEmail}
                    password={password} setPassword={setPassword}
                    showPassword={showPassword} setShowPassword={setShowPassword}
                    loading={loading} isMobile={isMobile} onSubmit={auth}
                />
                <LoginFooter isMobile={isMobile} />
            </Box>
        </Box>
    );
}

export default Login;
